<div class="border border-gray-200 bg-white overflow-hidden rounded">
  
  <!-- Kategorie Header (klickbar) -->
  <div 
    class="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors text-base leading-6"
    [class.border-b]="isExpanded()"
    [class.border-gray-200]="isExpanded()"
    (click)="toggle()">
    
    <div class="flex items-center gap-3 flex-1">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="text-gray-500 mr-2 transition-transform"
        [class.rotate-180]="isExpanded()"
        aria-hidden="true">
        <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
      </svg>
      <div 
        class="w-3 h-3 rounded-full flex-shrink-0" 
        [style.background-color]="categorySum().category.color">
      </div>
      <span class="font-medium text-gray-900">{{categorySum().category.name}}</span>
      <span class="text-gray-500">({{categorySum().count}} Einträge)</span>
    </div>
    
    <div class="font-medium text-gray-900">
      {{formatDurationToStd(categorySum().sum)}}
    </div>
  </div>

  <!-- Kategorie Content (aufklappbar) -->
  @if (isExpanded()) {
    <div class="bg-white text-base leading-6">
      
      <!-- Zeiteinträge -->
      <div class="divide-y divide-gray-200">
        @for (timeEntry of timeEntries(); track timeEntry.id) {
          <app-timeEntry-list-item 
            [ownerId]="ownerId()"
            [timeEntry]="timeEntry">
          </app-timeEntry-list-item>
        }
      </div>

      <!-- Pagination -->
      @if (timeEntries().length > 0) {
        <div class="flex items-center justify-end gap-2 py-2 px-4 border-t border-gray-200">
          <button
            class="flex items-center justify-center w-[25px] h-[25px] rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            [style.background-color]="'rgb(229, 231, 235)'"
            [disabled]="!hasPreviousPage()"
            (click)="previousPage(); $event.stopPropagation()">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="text-gray-700 rotate-90"
              aria-hidden="true">
              <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
            </svg>
          </button>
          
          <button
            class="flex items-center justify-center w-[25px] h-[25px] rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            [style.background-color]="'rgb(229, 231, 235)'"
            [disabled]="!hasNextPage()"
            (click)="nextPage(); $event.stopPropagation()">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="text-gray-700 -rotate-90"
              aria-hidden="true">
              <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
      }
    </div>
  }
</div>
